<template>
  <Loading v-if='loading' class='center' color='#2faeff' type='spinner' vertical>加载中...</Loading>
  <div v-else @click.capture='clickCapture'>
    <NoticeBar v-if='$store.getters.getIsPreview && $store.getters.getIsPreview === 1' background='#FFF6EF'
               color='#FA964E' text='提示：当前为预览页面，答案不被记录' />
    <div class='cover'>
      <!-- 填报记录按钮 -->
      <!--<div v-if='$store.getters.getToken && $store.getters.getQuesInfo.type === 1' class='record-btn' @click='handleJump2Record'>-->
      <!--  填报记录-->
      <!--</div>-->
      <!-- 更多按钮 -->
      <!--<MoreBtn v-if='moreBtnsShow' @showLeaderBoard='showLeaderBoard = true' @showTips='tipsPopup = true' />-->
      <!-- 标题 -->
      <!--<h1 v-if='quesInfo?.titleStatus' class='title'>{{ quesInfo?.title }}</h1>-->
      <!-- 描述 -->
      <!--<div :class="{ 'ques-tips': quesInfo?.type === 1 }" class='tips' v-html='quesInfo?.content'></div>-->
      <!-- 说明弹窗 -->
      <!--<TipsPopup v-if='tipsPopup' :content='quesInfo?.content' @close='tipsPopup = false'></TipsPopup>-->
      <!-- 答题榜 -->
      <ActionSheet v-model:show='showLeaderBoard'>
       <LeaderBoard />
      </ActionSheet>
      <!-- 地图 -->
      <div ref='chartRef' class='charts-map'></div>
      <!-- 排行榜 -->
      <div class='rank-list-btn' @click="() => {
                handleJump2('competitionRank')
                handleBuryPointClick('参赛排行')
              }">
        <div>排</div>
        <div class='test'>行</div>
        <div class='test'>榜</div>
      </div>

      <div class='rank-list-btn rank-list-btn2' @click="() => {
                handleJump2('little-rule')
                handleBuryPointClick('排行规则')
              }">
        <div>规</div>
        <div class='test'>则</div>
      </div>

      <div class='form-box'>
        <div class='form-title'>
          <div class='text'>为</div>
          <div class='city-name'>{{ cityText }}</div>
          <div class='text'>而战</div>
        </div>

        <Form class='i-van-form'>
          <CellGroup>
            <Field
              v-model='formData.area'
              :disabled='cityList.length === 0'
              :placeholder="cityList.length > 0 ? '请选择您所在的地区' : '请在地图上点击您的城市'"
              :rules="[{ required: true, message: '请选择您所在的地区' }]"
              is-link
              label='地区'
              name='picker'
              readonly
              @click='showPicker = true'
            />
            <Teleport to='body'>
              <Popup v-model:show='showPicker' position='bottom'>
                <Picker
                  :columns='cityList'
                  @cancel='showPicker = false'
                  @confirm='onSelectAreaHandle'
                />
              </Popup>
            </Teleport>
            <Field
              v-model='formData.school'
              :maxlength='50'
              :rules="[{ required: true, message: '请填写学校名称' }]"
              label='学校'
              name='学校'
              placeholder='请填写学校名称'
            />
            <Field
              v-model='formData.name'
              :maxlength='50'
              :rules="[{ required: true, message: '请填写您的姓名' }]"
              label='姓名'
              name='姓名'
              placeholder='请填写您的姓名'
            />
          </CellGroup>
        </Form>
      </div>

      <div class='btn-go' @click='handleSubmit'>
        <div class='text'>{{ `为${cityText}而战` }}</div>
        <div class='go'>GO</div>
        <div class='hand'></div>
      </div>

      <Password v-if='isPassword == 1' @onEmit='handlePasswordSubmit' />
      <PersonQues v-if='showPersonList' :personList='personList' @close='showPersonList = false'
                  @finishedPerson='handleFinishedPerson' />
    </div>
    <!-- pk加载匹配窗 -->
    <PkLoading v-if="showPkLoading" />
  </div>
</template>

<script>
import VConsole from 'vconsole'
import * as echarts from 'echarts'
import shandongMapData from '@/assets/data/shandongMap.json'
import axios from 'axios'
import { computed, nextTick, onMounted, reactive, ref, watch, watchEffect } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { ActionSheet, Button, CellGroup, Dialog, Field, Form, Icon, Loading, NoticeBar, Overlay, Popup, Picker, Notify } from 'vant'
import { WebBridgeApi } from 'ijsbridge'
import { getQueryString, isInApp as InApp } from '@/utils/tools'
import { getPessonQuesList } from '@/api/index'
import PersonQues from './components/personQues'
import LeaderBoard from './components/leaderboard'
import TipsPopup from './components/tipsPopup'
import MoreBtn from './components/moreBtn'
import PkLoading from '../index/components/pkLoading'
import Password, { useShowPasswordEffect } from '@/components/password/Password'
import { useCommonGetSubmitCount } from '@/effects/submitEffect'
import { getBindModuleInfo, getBindUserFirstSelectionList, getBindUserSecondSelectionList, getUserSelectionInfo, submitPersonInfo, updatePersonInfo } from '@/api/person'
import { useAppGoBack } from '@/hooks/index.js'
import { getWhiteList } from '@/api/rank'
import { useStartBtnClick } from '@/hooks'
import { DOWNLOAD_URL, DOWNLOAD_URL_LY, DOWNLOAD_URL_SD_NEWS_ANDROID, DOWNLOAD_URL_SD_NEWS_IOS, QUES_KEY_2023_4_12 } from '@/constants'
import { isAndroid } from 'vant/lib/utils'
import qs from 'qs'

export default {
  components: {
    Loading,
    Form,
    Field,
    CellGroup,
    TipsPopup,
    PersonQues,
    PkLoading,
    LeaderBoard,
    MoreBtn,
    ActionSheet,
    Password,
    Icon,
    Popup,
    Picker,
    Notify,
    Overlay,
    NoticeBar,
    Button
  },
  setup() {
    const loading = ref(true)
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    useTypeShowEffect()

    // 说明按钮
    const { showMoreBtn } = useMoreBtnEffect()

    const tipsPopup = ref(false)
    const showLeaderBoard = ref(false)

    // 获取答题次数
    const { isLimit, getLimitInfo, limtLoading } = useCommonGetSubmitCount()

    useWebLoginEffect(isLimit, getLimitInfo, loading)

    const { personList } = usePesonListEffect()

    // 是否展示pk匹配弹窗
    const showPkLoading = ref(false)

    // 不同按钮点击相关逻辑
    const { handleJump2, quesSetting, showPersonList, handleFinishedPerson } =
      useModuleClickEffect(isLimit, personList, showLeaderBoard, showPkLoading)

    // 按钮整体点击拦截处理
    const { clickCapture } = useClickEffect(isLimit, getLimitInfo, loading)

    // 答题密码相关
    const { isPassword, handlePasswordSubmit } = useShowPasswordEffect()

    const mFirstSelectionList = ref([]) // 一级
    const mSecondSelectionList = ref([]) // 二级
    function fetchBindUserFirstSelectionList() {
      loading.value = true
      getBindUserFirstSelectionList({
        typeId: store.getters.getModuleInfo?.typeId,
        orgId: store.getters.getOrgId,
        keyword: '',
        pageNo: 1,
        pageSize: 999
      }).then(res => {
        if (res.ok) {
          mFirstSelectionList.value = res.data.rows

          loading.value = false

          // 数据回显
          if (!!store.getters.getUserSelection?.name) {
            changeMapColor(store.getters.getUserSelection.firstName)
            setTimeout(() => {
              console.log('数据回显', store.getters.getUserSelection.secondName)
              initCharts()
              formData.value.area = store.getters.getUserSelection.secondName
              formData.value.school = store.getters.getUserSelection?.school || ''
              formData.value.name = store.getters.getUserSelection.name
            }, 100)
          } else {
            initCharts()
          }
        }
      })
    }

    const handleJump2Record = () => {
      router.push({
        path: '/person/record',
        query: route.query
      })
    }

    const btnSort = ref([])
    btnSort.value =
      store.getters.getBtnText?.btnSort.length == 0
        ? [0, 1, 2, 3, 4, 5, 6, 7, 8]
        : store.getters.getBtnText?.btnSort

    const moreBtnsShow = ref(false)
    moreBtnsShow.value =
      store.getters.getBtnText?.moreBtnsShow == '1' ? true : false

    watch(store.getters.getBtnText, (newValue, oldValue) => {
      btnSort.value =
        store.getters.getBtnText?.btnSort.length == 0
          ? [0, 1, 2, 3, 4, 5, 6, 7, 8]
          : store.getters.getBtnText?.btnSort
      moreBtnsShow.value =
        store.getters.getBtnText?.moreBtnsShow == '1' ? true : false
    })

    const questionActiveKey = getQueryString('questionActiveKey')

    // 埋点点击
    const handleBuryPointClick = (name) => {
      name &&
      useStartBtnClick({
        buttonName: name,
        quesTitle: store.getters.getQuesInfo?.title
      })
    }

    // 选择的城市
    const cityText = ref('城市')

    // 表单
    let formData = ref({
      area: '',
      school: '',
      name: ''
    })

    // 渲染地图
    let mapData = ref([
      { name: '济南市', value: 1 },
      { name: '青岛市', value: 1 },
      { name: '烟台市', value: 1 },
      { name: '潍坊市', value: 1 },
      { name: '菏泽市', value: 1 },
      { name: '日照市', value: 1 },
      { name: '威海市', value: 1 },
      { name: '枣庄市', value: 1 },
      { name: '临沂市', value: 1 },
      { name: '滨州市', value: 1 },
      { name: '东营市', value: 1 },
      { name: '淄博市', value: 1 },
      { name: '泰安市', value: 1 },
      { name: '聊城市', value: 1 },
      { name: '济宁市', value: 1 },
      { name: '德州市', value: 1 }
    ])
    const chartRef = ref({})

    function initCharts() {
      loading.value = false
      console.log('渲染地图')
      nextTick(() => {
        // 初始化统计图对象
        const myChart = echarts.init(chartRef.value)
        // 注册地图(数据放在axios返回对象的data中哦)
        echarts.registerMap('GX', shandongMapData)
        const option = {
          grid: {
            top: '0px',
            left: '0px',
            right: '0px',
            bottom: '0px'
          },
          dataRange: {
            show: false,
            x: 'left',
            y: 'bottom',
            splitList: [
              {
                start: 0, end: 3, color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: '#24B2A6'
                  }, {
                    offset: 1, color: '#7DC9A7'
                  }],
                  global: false
                }
              },
              {
                start: 4, end: 6, color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: '#FF9314'
                  }, {
                    offset: 1, color: '#FFBB39'
                  }],
                  global: false
                }
              }//当值为10时，区域背景
            ]
          },
          geo: {
            map: `GX`,
            aspectScale: 0.75, //长宽比
            zoom: 1.1,
            roam: false,
            itemStyle: {
              normal: {
                areaColor: `#10359b`,
                shadowColor: `#309A95`,
                shadowOffsetX: 5,
                shadowOffsetY: 5,
                borderColor: `#fff`,
                borderWidth: 3,
                shadowBlur: 1
              },
              emphasis: {
                borderWidth: 0,
                borderColor: 'transparent',
                //高亮区域颜色
                areaColor: '#000'
              }
            }
          },
          series: [
            {
              type: `map`,
              map: `GX`,
              aspectScale: 0.75, //长宽比
              zoom: 1.1,
              roam: false,
              selectedMode: false,
              label: {
                normal: {
                  show: true,
                  textStyle: {
                    color: `#FFF`,
                    fontSize: 12
                  }
                },
                emphasis: {//鼠标移入高亮显颜色
                  show: true,
                  textStyle: {
                    color: `#FFF`,
                    fontSize: 12
                  }
                }
              },
              itemStyle: {
                normal: {
                  areaColor: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                      offset: 0, color: '#24B2A6'
                    }, {
                      offset: 1, color: '#7DC9A7'
                    }],
                    global: false
                  },
                  borderColor: '#B8E8EB',
                  borderWidth: 1
                },
                emphasis: {//鼠标移入高亮显颜色
                  areaColor: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                      offset: 0, color: '#FF9314'
                    }, {
                      offset: 1, color: '#FFBB39'
                    }],
                    global: false
                  }
                }
              },
              data: mapData.value
            }
          ]
        }
        myChart.setOption(option)
        window.addEventListener('resize', () => {
          myChart.resize()
        })

        myChart.on('click', function(params) {//点击事件
          changeMapColor(params.name)

          setTimeout(() => {
            myChart.setOption(option)
          }, 100)
        })
      })
    }

    // 改变地图区块值
    function changeMapColor(value) {
      formData.value.area = ''
      cityText.value = value.replace(/市/g, '')
      mapData.value.forEach((item) => {
        if (item.name == value) {
          item.value = 5 // 地图变色

          mFirstSelectionList.value.forEach((val) => {
            if (val.name == value) {
              getBindUserSecondSelectionList({
                firstId: val.id,
                pageNo: 1,
                pageSize: 999,
                keyword: '',
                orgId: store.getters.getOrgId
              }).then(res => {
                if (res.ok) {
                  mSecondSelectionList.value = res.data.rows
                  cityList.value = res.data.rows.map(e => {
                    return e.name
                  })
                }
              })
            }
          })
        } else {
          item.value = 1
        }
      })
    }

    // 选择城市控制
    const showPicker = ref(false)
    const cityList = ref([])
    const onSelectAreaHandle = (e) => {
      formData.value.area = e
      showPicker.value = false
    }

    // 提交信息并跳转到正式答题
    const handleSubmit = () => {
      if (!formData.value.area || !formData.value.school || !formData.value.name) {
        Notify({ type: 'warning', message: '请完整填写信息' })
        return
      }

      let mData = {
        firstName: cityText.value + '市',
        firstId: '',
        secondName: formData.value.area,
        secondId: '',
        school: formData.value.school,
        name: formData.value.name,
        id: store.getters.getUserSelection?.id,
        questionActiveKey: questionActiveKey,
        token: store.getters.getToken
      }
      mData.firstId = mFirstSelectionList.value.find(item => item.name === cityText.value + '市').id
      mData.secondId = mSecondSelectionList.value.find(item => item.name === formData.value.area).id

      if (!!store.getters.getUserSelection?.name) {
        console.log(store.getters.getUserSelection)
        if (
          cityText.value + '市' === store.getters.getUserSelection?.firstName &&
          formData.value.area === store.getters.getUserSelection?.secondName &&
          formData.value.school === store.getters.getUserSelection?.school &&
          formData.value.name === store.getters.getUserSelection?.name) {
          handleJump2('exam')
          handleBuryPointClick('正式考试')
        } else {
          // 修改用户信息
          updatePersonInfo(qs.stringify(mData)).then(res => {
            if (res.ok) {
              handleJump2('exam')
              handleBuryPointClick('正式考试')
            } else {
              console.log(res.comment)
              Notify({ type: 'danger', message: res.comment })
            }
          })
        }
      } else {
        // 保存用户信息
        submitPersonInfo(qs.stringify(mData)).then(res => {
          if (res.ok) {
            handleJump2('exam')
            handleBuryPointClick('正式考试')
          } else {
            Notify({ type: 'danger', message: res.comment })
          }
        })
      }
    }

    // if (!store.getters.getToken) {
    //   console.log(321123312)
      initCharts()
    // }1

    watch(() => store.getters.getModuleInfo, (n) => {
        if (n) {
          if (!store.getters.getToken) {

          } else {
            fetchBindUserFirstSelectionList()
          }
        }
      }
    )

    return {
      chartRef,
      moreBtnsShow,
      showMoreBtn,
      tipsPopup,
      limtLoading,
      quesInfo: computed(() => store.getters.getQuesInfo),
      quesSetting,
      personList,
      showPersonList,
      handleJump2,
      clickCapture,
      isPassword,
      handlePasswordSubmit,
      showLeaderBoard,
      showPkLoading,
      handleFinishedPerson,
      handleJump2Record,
      btnSort,
      loading,
      questionActiveKey,
      handleBuryPointClick,
      QUES_KEY_2023_4_12,
      cityText,
      showPicker,
      cityList,
      onSelectAreaHandle,
      handleSubmit,
      formData
    }
  }
}

// 更多按钮显示逻辑
const useMoreBtnEffect = () => {
  const store = useStore()
  const showMoreBtn = computed(() => {
    // 开启登录 && （显示排行按钮 || 显示提示按钮 || 有个人选项信息）
    return JSON.parse(store.getters.getQuesInfo?.style)?.cover?.moreBtnsShow
  })
  return {
    showMoreBtn
  }
}

// 处理不同类型（问卷、闯关）跳转
const useTypeShowEffect = () => {
  const store = useStore()
  const router = useRouter()
  const route = useRoute()
  const quesSetting = store.getters.getQuesSetting
  const quesInfo = store.getters.getQuesInfo

  if (quesInfo?.type === 11) {
    router.replace({
      path: '/custom/sdws/home',
      query: {
        ...route.query
      }
    })
  }
  // 闯关
  if (quesSetting?.isLevel === 2 && quesInfo?.type !== 11) {
    router.replace({
      path: '/competition/home',
      query: {
        ...route.query
      }
    })
  }
}

// 捕获点击事件 做一些限制，比如登录处理、暂停收集处理
const useClickEffect = (isLimit, getLimitInfo, loading) => {
  const store = useStore()
  const router = useRouter()
  const route = useRoute()
  const quesInfo = store.getters.getQuesInfo
  const isInApp = InApp()
  const isPreview = getQueryString('isPreview')
    ? Number(getQueryString('isPreview'))
    : 0
  let flag = false
  // let message = '登录客户端后方可开始答卷哦，感谢您的配合~'
  // 开启登录弹窗
  if (quesInfo?.isLogin === 1 && !store.getters.getToken) {
    flag = true
    // app里未登录 直接调用登录接口
    if (isInApp) {
      flag = true
      WebBridgeApi.authorize().then(({ err, result }) => {
        if (err === 'cancel') {
          // message = '登录客户端后方可开始答卷哦，感谢您的配合~'
          flag = true
          useAppGoBack()
        }
        const token = result.token || result.user.token
        store.commit('setToken', {
          token
        })
        store.commit('setUser', {
          user: {
            avatar: result.user.avatar,
            nickname: result.user.nickname,
            id: result.user.id
          }
        })
        if (store.getters.getQuesInfo?.type === 1) {
          store.dispatch('getAdminTree')
        }
        useFetchPersonInfo(store, loading)
        fetchWhiteList(store)
        getLimitInfo(isLimit)
        flag = false
        // localStorage.setItem('token', token)
      })
    }
  }
  const clickCapture = (e, type) => {
    // 预览不做处理
    if (isPreview === 1) {
      return
    }

    if ((quesInfo?.status === 3 || quesInfo?.status === 4) && !type) {
      Dialog({ message: '此系统已暂停收集，请等待再次开启后使用！' })
      e.stopPropagation()
      return
    }
    if (quesInfo?.status === 5 && !type) {
      Dialog({ message: '活动未开始' })
      e.stopPropagation()
      return
    }

    const orgid = getQueryString('orgid')
    // 登录类型设置为2的时候， 网页里即使已经登录 也需要跳转下载页
    if (quesInfo?.webLogin === 2 && !isInApp) {
      let url = `${DOWNLOAD_URL}?orgid=${orgid}`

      if (orgid === '409') {
        url = DOWNLOAD_URL_LY
      } else if (orgid === '21') {
        if (isAndroid()) {
          url = DOWNLOAD_URL_SD_NEWS_ANDROID
        } else {
          url = DOWNLOAD_URL_SD_NEWS_IOS
        }
      } else {
        url = `${DOWNLOAD_URL}?orgid=${orgid}`
      }

      window.open(url)
      e.stopPropagation()
    }
    if (quesInfo?.isLogin === 1 && !isInApp) {
      if (!store.getters.getToken) {
        e.stopPropagation()
        // 到自定义登录
        if (quesInfo?.webLogin === 3) {
          router.push({
            path: '/login',
            query: route.query
          })
        } else {
          handleWebLogin(store.getters.getQuesInfo)
        }
      } else {
        return
      }
    }
    if (!flag) {
      return
    }
    if (isInApp) {
      WebBridgeApi.authorize().then(({ err, result }) => {
        if (err === 'cancel') {
          // message = '登录客户端后方可开始答卷哦，感谢您的配合~'
          flag = true
          WebBridgeApi.router({ route: 'back' })
        }
        const token = result.user.token

        store.commit('setToken', {
          token
        })
        useFetchPersonInfo(store, loading)
        getLimitInfo(isLimit)

        flag = false
      })
    }
    e.stopPropagation()
  }

  return {
    clickCapture
  }
}

// 不同模块路由跳转
const useModuleClickEffect = (isLimit, personList, showLeaderBoard, showPkLoading) => {
  const store = useStore()
  const router = useRouter()
  const route = useRoute()
  const showPersonList = ref(false)

  if (route.query.showPersonList) {
    showPersonList.value = true
  }

  let jumpUrl = reactive({})
  const isPreview = getQueryString('isPreview')
    ? Number(getQueryString('isPreview'))
    : 0
  const isSetting = getQueryString('isSetting')
  const quesSetting = store.getters.getQuesSetting
  // 没有添加任何模块
  if (
    quesSetting?.isStudy === 1 &&
    quesSetting?.isMock === 1 &&
    quesSetting?.isExam === 1 &&
    quesSetting?.isLevel === 1
  ) {
    Dialog({ message: '尚未添加任何模块，请先添加模块' })
  }

  const handleJump2 = (type) => {
    if (
      store.getters.getQuesInfo?.status === 7 &&
      (type === 'exam' || type === 'list')
    ) {
      Dialog({ message: '已到作答最大参与数量，感谢参与！' })
      return
    }

    if (
      store.getters.getQuesInfo?.status === 6 &&
      (type === 'exam' || type === 'study' || type == 'mock' || type === 'list')
    ) {
      Dialog({ message: '活动已结束' })
      return
    }

    const param = {
      path: '/',
      query: {
        ...route.query,
        type: type
      }
    }

    // 没有排行配置 直接弹窗
    if (type === 'competitionRank' && !store.getters.getRankConfig) {
      showLeaderBoard.value = true
      return
    }

    if (isSetting) {
      // 设置样式时的预览,这里是给pc预览页面时候用的
      if (type === 'record') {
        param.path = '/person'
        // url = `/person?questionActiveKey=${questionActiveKey}`
      } else if (type === 'study') {
        param.path = '/single/1'
        param.query.isStudy = true
      } else if (type === 'explain') {
        param.path = '/explain'
      } else if (type === 'competitionRank') {
        param.path = '/person/competitionrank'
      } else if (type === 'rank') {
        param.path = '/person/rank'
      } else if (type === 'score') {
        param.path = '/person/score'
      } else if (type === 'info') {
        param.path = '/person/info'
      } else if (type === 'record') {
        param.path = '/person'
      } else if (type === 'admin') {
        param.path = '/admin'
      } else if (type === 'little-rule') {
        param.path = '/little-rule'
      } else {
        param.path = '/list'
      }
      parent.postMessage(
        {
          type: 'forword'
        },
        '*'
      )
    } else {
      if (type === 'exam' && store.getters.getIsBlock) {
        Dialog({ message: '抱歉，您还不具备参与资格！' })
        return
      }
      // 正常时候
      if (
        (type === 'exam' ||
          (store.getters.getQuesInfo?.type === 1 && type === 'list')) &&
        !isLimit.value &&
        isPreview !== 1
      ) {
        Dialog({ message: '已超过次数限制' })
        return
      }
      if (type === 'list') {
        param.path = '/list'
      } else if (type === 'study') {
        param.path = '/single/1'
        param.query.isStudy = true
      } else if (type === 'explain') {
        param.path = '/explain'
      } else if (type === 'competitionRank') {
        param.path = '/person/competitionrank'
      } else if (type === 'rank') {
        param.path = '/person/rank'
      } else if (type === 'score') {
        param.path = '/score'
      } else if (type === 'info') {
        param.path = '/person/info'
        param.query.typeId = store.getters.getModuleInfo?.typeId
      } else if (type === 'record') {
        param.path = '/person/record'
      } else if (type === 'little-rule') {
        param.path = '/little-rule'
      } else if (type === 'admin') {
        param.path = '/admin'
      } else {
        if (quesSetting && quesSetting.showType === 1) {
          param.path = '/list'
        } else if (quesSetting.showType === 2) {
          param.path = '/single/1'
        } else {
          return null
        }
      }
    }

    // pk需要去pk页面
    if (quesSetting?.isLevel === 3 && type === 'exam') {
      showPkLoading.value = true
      return
    }

    const quesInfo = store.getters.getQuesInfo
    const userSelectionInfo = store.getters.getUserSelection
    // 问卷绑定了个人信息 && 用户没有回答过 需要跳到个人信息页面去
    /*if (
      isPreview !== 1 &&
      !userSelectionInfo &&
      quesInfo.isLogin === 1 &&
      (type === 'list' || 'single') &&
      quesInfo.moduleId
    ) {
      param.query.oldPath = param.path
      param.path = '/person/info'
      param.query.first = 1

      router.push(param)

      return
    }*/

    if (type === 'other') {
      if (store.getters.getBtnText?.otherUrl.startsWith('http')) {
        window.location.href = store.getters.getBtnText?.otherUrl

        return
      } else {
        const quesInfo = store.getters.getQuesInfo
        router.push({
          path: store.getters.getBtnText?.otherUrl,
          query: { questionActiveKey: quesInfo.setting.questionActiveKey }
        })
      }

      return
    }

    // 有个人题型的答题之前需要弹一下框
    if (
      personList.value.length > 0 &&
      // isPreview !== 1 &&
      type !== 'record' &&
      type !== 'study' &&
      type !== 'mock' &&
      type !== 'rank' &&
      type !== 'info'
    ) {
      showPersonList.value = true
      jumpUrl = param

      return
    }

    // 记录答题开始时间
    store.commit('setStartTime', {
      time: new Date()
    })
    router.push(param)
  }

  // 答完个人题
  const handleFinishedPerson = () => {
    // 记录答题开始时间
    store.commit('setStartTime', {
      time: new Date()
    })
    router.push(jumpUrl)
  }

  return {
    quesSetting,
    showPersonList,
    handleJump2,
    handleFinishedPerson
  }
}

// 获取个人题型
const usePesonListEffect = () => {
  const personList = ref([])
  const store = useStore()
  let type = 1
  if (store.getters.getQuesInfo?.type !== 1) {
    type = 2
  }

  // 有缓存给赋值
  const setHistroyData = () => {
    const historyData = JSON.parse(
      JSON.stringify(store.getters.getInputCacheListObj)
    )
    // 遍历缓存数据 如果有答题记录 则赋值
    personList.value.forEach((item) => {
      const history = historyData[item.questionKey]
      if (history) {
        item.value = history[history.length - 1]
      }
    })
  }

  const getData = async () => {
    const res = await getPessonQuesList({
      questionActiveKey: getQueryString('questionActiveKey'),
      type
    })

    personList.value = res?.data
    setHistroyData()
  }

  // 报名的时候 个人题型不需要在外边展示
  if (store.getters.getQuesInfo?.type !== 1) {
    getData()
  }

  return {
    personList
  }
}

// web登录
const handleWebLogin = (quesInfo) => {
  const isFromIframe = getQueryString('isFromIframe')
  // 如果是iframe进来的，postMessage出去 教给外层登陆
  if (isFromIframe) {
    // postMessage出去token
    parent.postMessage(
      {
        needLogin: true
      },
      '*'
    )
    return
  }

  const orgid = getQueryString('orgid')
  const backurl = encodeURIComponent(window.location.href)
  let url = `https://app-auth.iqilu.com?orgId=${orgid}&_orgid_=${orgid}&backurl=${backurl}`
  if (orgid === '29') {
    url = `https://app-auth.iqilu.com?isStyleTmp=1&orgId=${orgid}&_orgid_=${orgid}&backurl=${backurl}`
  }
  if (quesInfo?.webLogin === 2) {
    if (orgid === '21') {
      if (isAndroid()) {
        url = DOWNLOAD_URL_SD_NEWS_ANDROID
      } else {
        url = DOWNLOAD_URL_SD_NEWS_IOS
      }
    } else if (orgid === '409') {
      url = DOWNLOAD_URL_LY
    } else {
      url = `${DOWNLOAD_URL}?orgid=${orgid}`
    }
  }
  window.location.href = url
}

// 处理网页登录跳回来逻辑
const useWebLoginEffect = async (isLimit, getLimitInfo, loading) => {
  const store = useStore()
  const token = window.location.search.substr(1).split('=')[1]

  if (token && !store.getters.getToken) {
    const { data } = await axios.get(
      `https://app-auth.iqilu.com/member/login_state?__token__=${token}`
    )
    if (data?.code === 1) {
      store.commit('setUser', {
        user: {
          avatar: data?.data?.avatar,
          nickname: data?.data?.nickname,
          id: data?.data?.id
        }
      })
      if (data?.data?.token) {
        store.commit('setToken', {
          token: data?.data?.token
        })
        localStorage.setItem('token', data?.data?.token)
        let url = decodeURIComponent(window.location.href)
        if (url.indexOf('amp;') !== -1) {
          url = url.replace(/amp;/g, '')
        }
        window.location.replace(url)
        getLimitInfo(isLimit)
      }
    }
  }
  if (store.getters.getToken) {
    useFetchPersonInfo(store, loading)
    fetchWhiteList(store)
  }
}

// 获取白名单配置
const fetchWhiteList = async (store) => {
  const res = await getWhiteList({
    questionActiveKey: getQueryString('questionActiveKey'),
    token: store.getters.getToken
  })

  if (res.ok) {
    store.commit('setIsBlock', !res.data)
  }
}

// 获取问卷绑定个人信息
const useFetchPersonInfo = async (store, loading) => {
  const fetchData = async () => {
    // loading.value = true
    const res = await getUserSelectionInfo({
      questionActiveKey: getQueryString('questionActiveKey'),
      token: store.getters.getToken
    })
    // loading.value = false
    if (res.ok) {
      store.commit('setUserSelection', {
        data: res.data
      })
      // 查绑定的模板信息
      await useFetchModuleInfo(store, loading)
    }
  }

  await fetchData()
}

// 获取模板信息
const useFetchModuleInfo = async (store, loading) => {
  if (!store.getters.getQuesInfo.moduleId) {
    // loading.value = false
    return
  }
  const fetchData = async () => {
    const res = await getBindModuleInfo({
      moduleId: store.getters.getQuesInfo.moduleId,
      orgId: store.getters.getOrgId
    })
    if (res.ok) {
      store.commit('setModuleInfo', {
        data: res.data[0]
      })
    }
    // loading.value = false
  }

  await fetchData()
}
</script>

<style lang='scss' scoped>
.cover {
  margin: 0 auto;
  width: 750px;
  height: 1640px;
  padding-top: 450px;
  background-image: url("~@/assets/img/little-celebrity/bg.png") !important;
  background-size: 100% 100%;

  .record-btn {
    position: fixed;
    top: 80px;
    right: 10px;
    padding: 10px 20px;
    font-size: 34px;
    background-color: rgba($color: #000000, $alpha: 0.1);
    font-weight: 400;
    color: #000;
    border-radius: 20px;
  }

  .title {
    margin: 0 40px;
    padding-top: 88px;
    margin-bottom: 88px;
    font-weight: bold;
    // line-height: 48px;
    line-height: 1.2;
    text-align: center;
    font-size: 60px;
    color: #333333;
    line-height: 1.2;
  }

  .person-btn {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 20px;
    right: 23px;
    width: 60px;
    height: 45px;
    border-radius: 10px;
    //background-color: #f0f0f0;
    // height: 60px;
    // width: 182px;
    // height: 56px;
    // background: #dbeeff;
    // border-radius: 28px 0px 0px 28px;
    // font-size: 28px;
    // color: #3795ff;
    background: no-repeat center/100% url('../../assets/img/gengduo.svg');
  }

  .topArrow {
    position: relative;
    top: 60px;
    left: 683px;
    width: 0;
    height: 0;
    position: relative;
    border: 15px solid;
    border-color: transparent transparent #fff transparent;
  }

  .more-btn-list {
    position: absolute;
    top: 86px;
    right: 20px;
    border-radius: 10px;
    // height: 326px;
    background-color: #fff;
    box-shadow: 0px 0px 8px 0px rgba(86, 86, 86, 0.2);
    padding: 25px 25px 27px;

    .item {
      width: 190px;
      padding: 20px 0;
      text-align: left;
      font-size: 32px;
      font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
      Helvetica, Segoe UI, Arial, Roboto, 'PingFang SC', miui,
      'Hiragino Sans GB', 'Microsoft Yahei', sans-serif;
      border-bottom: 3px solid #d0d0d5;
      border-color: rgba(208, 208, 213, 0.2);
    }

    .item:last-child {
      border-color: rgba(208, 208, 213, 0);
    }

    .more-btn-item {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      height: 104px;
      font-size: 34px;
      font-weight: 400;
      color: #555555;
      border-bottom: 1px solid rgba($color: #565656, $alpha: 0.1);

      &:last-child {
        border: none;
      }

      span {
        margin-left: 26px;
      }
    }
  }

  .tips-img {
    display: block;
    position: relative;
    top: -28px;
    margin: 0 auto;
    width: 351px;
    height: 80px;
  }

  .tips {
    margin: 0 auto;
    box-sizing: border-box;
    padding: 26px 60px;
    width: 700px;
    height: 385px;
    overflow-y: scroll;
    background: #f0f0f0;
    border-radius: 10px;

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin: 25px 0;
    }

    p {
      margin: 20px 0;
      line-height: 1.5;
      font-size: 32px;

      &:first-child {
        margin: 0;
      }
    }
  }

  .ques-tips {
    margin-top: 88px;
    height: 666px;
  }

  .rank-list-btn {
    display: flex;
    flex-direction: column;
    font-size: 38px;
    font-weight: 600;
    color: #FF7827;
    padding: 15px 8px 15px 15px;
    background-color: #FFFFFF;
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
    position: absolute;
    top: 70px;
    right: 0;

    .test {
      margin-top: 5px;
    }
  }

  .rank-list-btn2 {
    top: 250px;
  }

  .charts-map {
    width: 750px;
    height: 500px;
  }

  .form-box {
    width: 680px;
    height: 450px;
    margin: 62px auto 0;
    background-image: url("~@/assets/img/little-celebrity/box.png");
    background-size: 100% 100%;
    position: relative;

    .form-title {
      width: 440px;
      height: 70px;
      padding-bottom: 20px;
      background-image: url("~@/assets/img/little-celebrity/text-box.png");
      background-size: 100% 100%;
      position: absolute;
      top: -42px;
      left: 50%;
      transform: translate(-50%, 0);
      display: flex;
      justify-content: center;
      align-items: flex-end;
      color: #10727A;

      .text {
        font-size: 35px;
        font-weight: 600;
        margin: 0 15px;
      }

      .city-name {
        font-size: 46px;
        font-weight: 600;
      }
    }

    ::v-deep .van-form {
      padding: 50px 20px 10px 10px;

      .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
        border: none;
      }

      .van-cell-group{
        background-color: transparent;
      }

      .van-cell {
        padding: 0;

        .van-cell__title {
          width: 1.8rem;
          height: 1.5rem;
          text-align: right;
          font-size: 0.65rem;
          line-height: 1.5rem;
          color: #10727A;
        }

        .van-cell__value {
          height: 2.3rem;
          color: #10727A;

          .van-field__body {
            height: 1.5rem;
            border: 1px solid rgba(16, 114, 122, 0.8);
            border-radius: 5px;

            .van-field__control {
              color: #10727A;
              font-size: 0.6rem;
              padding-left: 0.2rem;
            }
          }

          .van-field__error-message {
            height: 0.8rem;
            line-height: 1.6;
          }
        }

        .van-icon-arrow {
          display: none;
        }
      }
    }
  }

  .btn-go {
    width: 480px;
    height: 115px;
    margin: 50px auto 0;
    background-image: url("~@/assets/img/little-celebrity/btn.png");
    background-size: 100% 100%;
    position: relative;
    color: #FDFDFD;

    .text {
      line-height: 109px;
      font-size: 40px;
      text-align: center;
      font-weight: 600;
    }

    .go {
      font-size: 46px;
      font-weight: 600;
      position: absolute;
      top: 50%;
      right: 30px;
      transform: translate(0, -60%);
      font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
    }

    .hand {
      width: 95px;
      height: 95px;
      background-image: url("~@/assets/img/little-celebrity/hand.png");
      background-size: 100% 100%;
      position: absolute;
      top: 75px;
      right: -20px;
      animation: scaleAnimation 1s infinite;
    }

    @keyframes scaleAnimation {
      0% {
        transform: scale(.9); /* 初始大小 */
      }
      50% {
        transform: scale(1.1); /* 中间阶段的放大效果 */
      }
      100% {
        transform: scale(.9); /* 回到初始大小 */
      }
    }
  }
}

button {
  border: none;
}

// @media (min-width: 1200px) {
//   .cover {
//     /* prettier-ignore */
//     width: 1200px;
//   }
// }
</style>
